import {StateSelectedElements} from "../atoms";
import {GlobalCartHash, GlobalFragments} from "../../App-types";

export enum ConstructorEnvironment {
    cart = 'cart',
    gameboxAdmin = 'gameboxAdmin',
    presetAdmin = 'presetAdmin',
}

export interface ConstructorSettings {
    nonce: string
    action: string
    postAction?: string
}

export interface ConstructorPostAction {
    (imageId: string | number, selectedState: StateSelectedElements): void
}

export interface ConstructorPostAction {
    (fragments: GlobalFragments, cart_hash: GlobalCartHash ): void
}
